import { SearchRounded, LocationOnOutlined, CalendarMonthOutlined } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Loader from "../componnents/Loader";

const Container = styled.div`
  padding: 80px 30px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 40px;
  min-height: calc(100vh - 80px);
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.3));

  @media (max-width: 768px) {
    padding: 60px 16px 40px;
    gap: 32px;
  }
  
  @media (max-width: 480px) {
    padding: 40px 12px 20px;
    gap: 24px;
    min-height: calc(100vh - 60px);
  }
`;

const Heading = styled.h1`
  color: white;
  font-size: 3rem;
  text-align: center;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 2.2rem;
    margin-bottom: 16px;
  }
  
  @media (max-width: 480px) {
    font-size: 1.8rem;
    margin-bottom: 12px;
    padding: 0 8px;
  }
  
  @media (max-width: 320px) {
    font-size: 1.6rem;
  }
`;

const Subheading = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 40px;
  max-width: 600px;
  line-height: 1.6;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  margin: 0 auto 40px;
  padding: 0 16px;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 32px;
    max-width: 500px;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 24px;
    max-width: 100%;
    padding: 0 8px;
  }
  
  @media (max-width: 320px) {
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

const SearchContainer = styled.div`
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  max-width: 900px;
  width: 100%;
  gap: 10px;
  font-size: 14px;
  padding: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border-radius: 16px;
    max-width: 500px;
  }
  
  @media (max-width: 480px) {
    max-width: 100%;
    margin: 0 8px;
    padding: 12px;
  }
`;

const InputWrapper = styled.div`
  margin-left: 20px;
  border-radius: 33px;
  display: flex;
  flex-direction: column;
  align-items: start;
  flex: 1;
  
  @media (max-width: 768px) {
    margin-left: 0;
    padding: 0;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 12px;
    
    &:last-of-type {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.text_primary};

  svg {
    font-size: 20px;
    color: ${({ theme }) => theme.primary};
  }
`;

const Title = styled.div`
  color: #000;
  font-weight: 500;
  width: fit-content;
`;

const Desc = styled.input`
  width: 100%;
  padding: 8px 0;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 400;
  margin-top: 6px;
  font-size: 15px;
  border: none;
  outline: none;
  background: transparent;
  transition: all 0.3s ease;

  &:focus {
    border-color: ${({ theme }) => theme.primary};
  }

  &[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    filter: invert(0.5);
    opacity: 0.6;
    transition: 0.3s;
  }

  &[type="date"]::-webkit-calendar-picker-indicator:hover {
    opacity: 1;
  }

  &::placeholder {
    color: rgba(0, 0, 0, 0.4);
  }
`;

const Divider = styled.div`
  width: 1px;
  height: 50px;
  background: rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    width: 100%;
    height: 1px;
  }
`;

const SearchWrapper = styled.div`
  border-radius: 33px;
  display: flex;
  gap: 1px;
`;

const SearchButton = styled.button`
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 44px;
  min-width: 44px;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
  
  border-radius: 50%;
  background-color: ${({ theme }) => theme.primary};
  color: white;
  font-weight: 400;
  padding: 20px 22px;
  
  @media (max-width: 768px) {
    width: 100%;
    border-radius: 12px;
    padding: 16px;
    margin-top: 8px;
    
    svg {
      font-size: 24px !important;
    }
  }
  
  @media (max-width: 480px) {
    padding: 14px;
  }
`;

const Home = () => {

  const[location, setLocation] = useState("")
  const[CheckInDate, setCheckInDate] = useState("")
  const[CheckOutDate, setCheckOutDate] = useState("")
  const[loading, setLoading] = useState(true)
  const navigate = useNavigate();

  useEffect(() => {
    // Track if page resources are loaded
    const checkPageLoad = () => {
      // Check if document is fully loaded
      if (document.readyState === 'complete') {
        // Add a small minimum display time for smooth UX (500ms)
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
    };

    // If already loaded, check immediately
    if (document.readyState === 'complete') {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } else {
      // Wait for window load event (all resources including images)
      window.addEventListener('load', checkPageLoad);
    }

    return () => {
      window.removeEventListener('load', checkPageLoad);
    };
  }, []);

  const handleSearchClick = () => {
    navigate ("/properties", {
      state :{location, CheckInDate, CheckOutDate}
    })
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearchClick();
    }
  }
  

  return (
    <>
      <Loader isLoading={loading} />
      <Container>
      <div>
        <Heading>Find Your Perfect Stay</Heading>
        <Subheading>
          Discover unique homes and experiences around the world. Book with confidence and travel with ease.
        </Subheading>
      </div>
      <SearchContainer>
        <InputWrapper>
          <IconWrapper>
            <LocationOnOutlined />
            <Title>Location</Title>
          </IconWrapper>
          <Desc 
            placeholder="Where are you going?" 
            type="text" 
            value={location}
            onChange={(e)=> setLocation(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </InputWrapper>

        <Divider />

        <InputWrapper>
          <IconWrapper>
            <CalendarMonthOutlined />
            <Title>Check In</Title>
          </IconWrapper>
          <Desc 
            placeholder="Add date" 
            type="date"
            value={CheckInDate}
            onChange={(e)=> setCheckInDate(e.target.value)}
          />
        </InputWrapper>

        <Divider />

        <InputWrapper>
          <IconWrapper>
            <CalendarMonthOutlined />
            <Title>Check Out</Title>
          </IconWrapper>
          <Desc 
            placeholder="Add date" 
            type="date"
            value={CheckOutDate}
            onChange={(e)=> setCheckOutDate(e.target.value)}
          />
        </InputWrapper>

        <SearchWrapper>
          <SearchButton onClick={handleSearchClick}>
            <SearchRounded sx={{color:"inherit", fontSize : "30px"}}/>
          </SearchButton>
        </SearchWrapper>

      </SearchContainer>
    </Container>
    </>
  );
};

export default Home;
